<template>
  <div class="vc-async-loading">
    <vc-loading></vc-loading>
  </div>
</template>

<script>
export default {
  name: 'vc-async-loading'
}
</script>

<style scoped>
.vc-async-loading {
  width: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/vc-cat/vc-async-loading.vue